const ShortArrow = ({ width = '100%', height = '100%' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 62.828 32.414">
            <path
                d="M1.414 1.414l30 30 30-30"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
            />
        </svg>
    )
}

export default ShortArrow
